import { supabase } from '../supabase-client';

import { createLogger } from '@xanectech/lib';
import type { Json } from '@xanectech/types';

const logger = createLogger('Supabase-Client - logging');

export interface AuditEventParams {
  action: string;
  resource_type: string;
  details: Json;
  resource_id?: string;
}

export interface WebAuthnEventParams {
  event_type: string;
  details: Json;
  severity: string;
  credential_id: string | undefined;
}

/**
 * Log an audit event securely via RPC.
 * This runs as a SECURITY DEFINER function on the server, enforcing auth.uid().
 */
export const logAuditEvent = async (params: AuditEventParams) => {
  const { error, data } = await supabase.rpc('log_audit_event', params);
  if (error) {
    logger.error('Failed to log audit event:', error);
    throw error;
  }
  return data;
};

/**
 * Log a WebAuthn security event securely via RPC.
 */
export const logWebAuthnEvent = async (params: WebAuthnEventParams) => {
  const { error, data } = await supabase.rpc('log_webauthn_event', {
    event_type: params.event_type,
    details: params.details,
    severity: params.severity,
    credential_id: params.credential_id ?? '',
  });
  if (error) {
    logger.error('Failed to log webauthn event:', error);
    throw error;
  }
  return data;
};
